import {createAction} from '@reduxjs/toolkit'

export const schedulePageLoaded = createAction<{totalScheduleItems: number}>('SCHEDULE_PAGE_LOADED')
